import React, {useContext, useState} from "react";
import {AppContext} from "../App";
import {useHistory} from "react-router-dom";
import {IAccordionLesson} from "../interfaces/IAccordionLesson";
import PieProgress from "./v2/Task/PieProgress";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/pro-light-svg-icons";
import {faCheckCircle as faCheckCircleOutline} from "@fortawesome/pro-regular-svg-icons";
import {faLightbulbOn, faPenNib, faQuestion, faText, faVolume} from "@fortawesome/pro-solid-svg-icons";

function Accordion(p: IAccordionLesson) {
    const [collapsed, toggleCollapsed] = useState<boolean>(false);
    let taskItems: any = p.tasks;
    let taskItemElements: any = [];
    const context = useContext(AppContext);
    let history = useHistory();

    function isItemLocked(taskNo: number) {
        if(p.currentWeek > Number(context.currentWeekNo)) {
            return false;
        } else if (p.currentTask >= taskNo) {
            return false;
        } else {
            return true;
        }
    }

    function isItemCompleted(taskNo: number){
        if(context.isCompleted){
            return true;
        }
        if(p.currentWeek > Number(context.currentWeekNo)) {
            return true;
        } else if(p.currentTask > taskNo){
            return true;
        } else {
            return false;
        }
    }

    function isCurrentTask(taskNo: number) {
        return (taskNo === p.currentTask)
    }

    if(taskItems) {
        taskItems.forEach((taskItem:any) => {
            const taskListIcon = function (isLocked: boolean) : any {
                if(taskItem.type === "intro") {
                    return (<FontAwesomeIcon icon={faLightbulbOn} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                } else if(taskItem.type === "listen") {
                    return (<FontAwesomeIcon icon={faVolume} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                } else if(taskItem.type === "read") {
                    return (<FontAwesomeIcon icon={faText} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                } else if(taskItem.type === "quiz") {
                    return (<FontAwesomeIcon icon={faQuestion} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                } else if(taskItem.type === "writing") {
                    return (<FontAwesomeIcon icon={faPenNib} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                } else {
                    return (<FontAwesomeIcon icon={faLightbulbOn} className={(isLocked) ? 'task-icon-locked': 'task-icon'}/>);
                }
            }

            taskItemElements.push(
                <div key={taskItem.id} className={(isCurrentTask(taskItem.ordering_number)) ? 'task-item-active' : 'task-item'} onClick={()=>{
                    if(!isItemLocked(taskItem.ordering_number))
                    {
                        //context.setActiveTask(tasks[i]);
                        context.setCurrentTaskNo(taskItem.ordering_number - 1);
                        context.setCurrentLessonNo(taskItem.lesson_no);
                        context.setCurrentStepNo(0);
                        console.log("Week = ", context.currentWeekNo, "Task = ", context.currentTaskNo, "Step = ", context.currentStepNo);
                        history.push(`/task-view/${context.deviceId}/${context.recoveryId}`);
                    } else {
                        p.onClickWhileLocked()
                    }
                }}>
                    <div className={'task-detail'}>
                        {taskListIcon(isItemLocked(taskItem.ordering_number))}
                        <div className={'task-title'}>
                            <p className={(isItemLocked(taskItem.ordering_number)) ? 'locked-task-title' : ''}>{taskItem.title}</p>
                        </div>
                    </div>
                    <div className={'task-status'}>
                        {(isItemCompleted(taskItem.ordering_number)) ?
                            <FontAwesomeIcon icon={faCheckCircleOutline} className={'status-icon'} style={{fontSize: 16}}/> : ''
                        }
                    </div>
                    <div className={'line'}/>
                </div>
            );
        })
    }


    return (
        <div className={'accordion-root'}>
            <div className={'header'}  onClick={()=>{
                let _collapsed: boolean = collapsed;
                toggleCollapsed(!_collapsed);
            }}>
                <div className={'left-panel'}>
                    <PieProgress  percentage={p.progress}/>
                    <div className={'lesson-label'}>Lesson {p.lessonNo}</div>
                </div>
                <div className={'right-panel'}>
                    <div className={'minutes'}>{p.durationInMinutes} MINUTES</div>
                    {(collapsed) ?
                        ( <FontAwesomeIcon icon={faChevronDown} className={'collapse-control'}/> ) :
                        ( <FontAwesomeIcon icon={faChevronUp} className={'collapse-control'}/> )
                    }
                </div>
                {(!collapsed) ? ( <div className={'line'}/> ) : ''}
            </div>
            {(!collapsed) ? (<div className={'task-items-elements'}>
                {taskItemElements}
            </div> ) : ''}
        </div>
    )
}

export default Accordion;